<section class="team-hero-area fixed-height parallaxBg bg-img" data-bg="assets/img/fondo-gerencia.jpg"
    style="background-image: none;"
    data-jarallax-original-styles="background-image: url(&quot;assets/img/team/fondo-gerencia.jpg&quot;);">
    <div class="container h-100">
        <div class="row team-member-item h-100">
            <div class="col-lg-7 text-center m-auto">
                <div class="about-us-content white mt-70 mt-sm-50">
                    <h2 style="font-size: 35px; margin-bottom: 0px; line-height: 1.4;">Gerencia del Centro
                        Histórico</h2>
                    <p style="font-weight:200;">Responsable de la gestión y conservación
                        del Centro Histórico y de las Areas Históricas de la ciudad del Cusco</p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-40 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/gerencia/fondo-gerencia.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <div class="col-lg-6 text-center">
              <div class="">
                  <h2>NATURALEZA JURÍDICA</h2>
                  <p class="m-0" style="font-size: 16px; line-height: 1.9;">La Gerencia de Centro
                      Histórico, es un órgano de línea de segundo nivel organizacional, responsable de la
                      gestión y conservación del Centro Histórico y de las Areas Históricas de la ciudad
                      del Cusco, así como la formulación e implementación de planes y proyectos
                      específicos en función de las actividades productivas y sociales, de acuerdo a las
                      políticas de desarrollo municipal, conservación del patrimonio cultural y natural,
                      en armonía con las normas locales, nacionales e internacionales vigentes.<br><br>
                      Está a cargo de un Gerente, quien depende jerárquicamente del Gerente Municipal.
                    </p>
              </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/gerencia/gerente.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">ARQ. ELILUZ PALOMINO MORMONTOY</h3>
                    <h6 class="designation mb-20" style="text-align: center;">GERENTE</h6>

                </div>
            </div>
          </div>
      </div>
  </div>
</section>
<section class="contact-creative-hero">
  <div class="container-fluid p-0">
      <div class="row align-items-center no-gutters">
          <div class="col-md-12">
            <img src="assets/img/gerencia/gerencia.jpg" alt="Girl in a jacket" width="100%" height="800">
          </div>
      </div>
  </div>
</section>
<section class="row pt-80">
  <div class="col-lg-6 m-auto text-center">
      <div class="section-title-wrap">
          <h2>FUNCIONES DE LA GERENCIA</h2>
          <p class="mb-0" style="font-weight: 300;">Son funciones de la Gernecia de Centro Histórico, las siguientes:</p>
      </div>
  </div><!-- End Section title -->
</section>
<section class="row pb-80" >
  <div class="col-lg-3 m-auto">
      <div class="accordion-element-1">
          <div class="restaurant-why-us-accordion" id="accordionOne">
              <div class="card">
                  <div class="card-header" id="headingOne">
                      <h3 data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                          class="collapsed" style="color: white;"><span>01.</span> Políticas municipales</h3>
                  </div>
                  <div id="collapseOne" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Planificar, organizar, conducir y evaluar las políticas municipales en materia de
                              conservación, organización del espacio físico y uso del suelo en el ámbito del
                              Centro Histórico y Áreas Históricas.</p>
                      </div>
                  </div>
              </div><!-- Start Accordion item #02 -->
              <div class="card">
                  <div class="card-header" id="headingTwo">
                      <h3 data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                          class="collapsed" style="color: white;"><span>02.</span>Plan Operativo</h3>
                  </div>
                  <div id="collapseTwo" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Formular, ejecutar y evaluar su Plan Operativo, así como el Cuadro de
                              Necesidades.</p>
                      </div>
                  </div>
              </div><!-- Start Accordion item #03 -->
              <div class="card">
                  <div class="card-header" id="headingThree">
                      <h3 data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                          class="collapsed" style="color: white;"><span>03.</span> Memoria anual</h3>
                  </div>
                  <div id="collapseThree" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Formular la memoria anual de su dependencia de acuerdo a la normatividad vigente.
                          </p>
                      </div>
                  </div>
              </div><!-- Start Accordion item #04 -->
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapseFour" style="color:white;"><span>04.</span> Gastos anual
                          mensualizado
                      </h3>
                  </div>
                  <div id="collapseFour" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Formular su cronograma de gastos anual mensualizado, de acuerdo a la normatividad
                              vigente.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="heading5">
                      <h3 data-toggle="collapse" data-target="#collapse5" style="color:white;"><span>05.</span> Planes específicos
                          de desarrollo
                      </h3>
                  </div>
                  <div id="collapse5" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Formular, conducir, evaluar y proponer planes específicos de desarrollo y
                              conservación de Áreas Históricas en la Provincia del Cusco.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="heading6">
                      <h3 data-toggle="collapse" data-target="#collapse6" style="color:white;"><span>06.</span> Proyectos de
                          revitalización
                      </h3>
                  </div>
                  <div id="collapse6" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Elaborar, formular y evaluar los proyectos de revitalización, rehabilitación y
                              renovación urbana en función de los requerimientos del Centro Histórico, Áreas
                              Históricas y de influencia.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="heading7">
                      <h3 data-toggle="collapse" data-target="#collapse7" style="color:white;"><span>07.</span> Acuerdos y
                          convenios
                      </h3>
                  </div>
                  <div id="collapse7" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Proponer acuerdos, convenios y cesiones mutuas con otras municipalidades
                              provinciales, distritales y otras instituciones tutelares para gestión y
                              conservación del patrimonio cultural y natural..</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="heading7">
                      <h3 data-toggle="collapse" data-target="#collapse8" style="color:white;"><span>08.</span> Plan Vial del
                          Centro Histórico
                      </h3>
                  </div>
                  <div id="collapse8" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Participar en el Plan Vial del Centro Histórico, en concordancia con el Plan Vial
                              regional y nacional.</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="col-lg-3 m-auto">
      <div class="accordion-element-1">
          <div class="restaurant-why-us-accordion" id="accordionOne">
              <div class="card">
                  <div class="card-header" id="heading9">
                      <h3 data-toggle="collapse" data-target="#collapse9" style="color:white;"><span>09.</span>Plan de Acciones de
                          Conservación
                      </h3>
                  </div>
                  <div id="collapse9" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Formular, conducir, evaluar y proponer el Plan de Acciones de Conservación del
                              Patrimonio Histórico Cultural y Paisajístico, en concordancia con el Plan
                              Maestro del Centro Histórico del Cusco.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="heading10">
                      <h3 data-toggle="collapse" data-target="#collapse10" style="color:white;"><span>10.</span> Elaborar programas
                          de fomento
                      </h3>
                  </div>
                  <div id="collapse10" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Elaborar programas de fomento de conservación, desarrollo socio económico y
                              cultural.
                          </p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="heading10">
                      <h3 data-toggle="collapse" data-target="#collapse11" style="color:white;"><span>11.</span> Conservación de
                          zonas
                      </h3>
                  </div>
                  <div id="collapse11" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Elaborar y proponer proyectos para la conservación de las zonas monumentales, de
                              inmuebles declarados monumentos históricos, artísticos y de valoración cultural.
                          </p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="heading10">
                      <h3 data-toggle="collapse" data-target="#collapse12" style="color:white;"><span>12.</span> Administrar y
                          mantener
                      </h3>
                  </div>
                  <div id="collapse12" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Administrar, sistematizar, dirigir, y mantener actualizado un archivo
                              especializado con documentos urbanos específicos en zonas de interés
                              arquitectónico. social, comercial, institucional, de transito, de política
                              municipal, histórico, monumental, paisajístico y otros.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingOne">
                      <h3 data-toggle="collapse" data-target="#collapse13" aria-expanded="false"
                          class="collapsed" style="color:white;"><span>13.</span> Proyectos de vivienda</h3>
                  </div>
                  <div id="collapse13" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Controlar los programas y proyectos de vivienda en los asuntos que le compete,
                              manteniendo un archivo catalogado e intangible de los planos generales del
                              Centro Histórico, Áreas Históricas y de influencia, sus redes de servicios
                              públicos, equipamiento social, monumentos arqueológicos, histórico artísticos en
                              general de todos los asuntos de interés y necesidad para la ciudad.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingTwo">
                      <h3 data-toggle="collapse" data-target="#collapse14" aria-expanded="false"
                          class="collapsed" style="color:white;"><span>14.</span>Proponer proyectos de Ordenanzas</h3>
                  </div>
                  <div id="collapse14" class="collapse" data-parent="#accordionOne" style="">
                      <div class="card-body">
                          <p>Proponer proyectos de Ordenanzas, Acuerdos, Resoluciones y normas que regulen el
                              desarrollo urbano, la protección del patrimonio cultural, natural y/o trámites
                              administrativos de su competencia.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingThree">
                      <h3 data-toggle="collapse" data-target="#collapse15" aria-expanded="false"
                          class="collapsed" style="color:white;"><span>15.</span> Proponer normas de construcción</h3>
                  </div>
                  <div id="collapse15" class="collapse" data-parent="#accordionOne" style="">
                      <div class="card-body">
                          <p>Proponer normas de construcción, técnicas y administrativas para la conservación
                              del Centro Histórico.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse16" style="color:white;"><span>16.</span> Trámites
                      </h3>
                  </div>
                  <div id="collapse16" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Revisar, proponer, aprobar, visar y dar trámite según corresponda a los
                              documentos que de conformidad con sus respectivas funciones formulen las
                              unidades orgánicas de la Gerencia de Centro Histórico.</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="col-lg-3 m-auto">
      <div class="accordion-element-1">
          <div class="restaurant-why-us-accordion" id="accordionOne">
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse17" style="color:white;"><span>17.</span> Índices de
                          productividad
                      </h3>
                  </div>
                  <div id="collapse17" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Establecer, dar seguimiento y evaluar los índices de productividad y eficiencia
                              en la ejecución e implementación de proyectos en el Centro Histórico del Cusco.
                          </p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse18" style="color:white;"><span>18.</span> Hacer cumplir las
                          disposiciones
                      </h3>
                  </div>
                  <div id="collapse18" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Cumplir y hacer cumplir las disposiciones y normas vigentes respecto a la
                              ejecución de obras públicas y privadas, el plan vial de señalización y otros en
                              el Centro Histórico de Cusco.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse19" style="color:white;"><span>19.</span> Comisión Técnica
                          Calificadora
                      </h3>
                  </div>
                  <div id="collapse19" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Presidir la Comisión Técnica Calificadora de Proyectos para el Centro Histórico
                          </p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse20" style="color:white;"><span>20.</span>Resoluciones en
                          primera instancia
                      </h3>
                  </div>
                  <div id="collapse20" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Emitir Resoluciones en primera instancia de los procedimientos administrativos de
                              su competencia, previo informe Técnico y Legal de su dependencia.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse23" style="color:white;"><span>21.</span> Plan Maestro del
                          Centro Histórico
                      </h3>
                  </div>
                  <div id="collapse23" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Formular, organizar, conducir, evaluar y proponer el Plan Maestro del Centro
                              Histórico de acuerdo con el Plan de Acondicionamiento Territorial y Plan de
                              Desarrollo Urbano.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse21" style="color:white;"><span>22.</span> Otorgar Licencia
                      </h3>
                  </div>
                  <div id="collapse21" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Otorgar Licencia de Obra en el Centro Histórico.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse29" style="color:white;"><span>23.</span> Unidades
                          Especiales de Gestión
                      </h3>
                  </div>
                  <div id="collapse29" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Ser miembro conformante de las Unidades Especiales de Gestión y otras que
                              coadyuven la administración del Centro Histórico de Cusco, áreas históricas y de
                              influencia.</p>
                      </div>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header" id="headingFour">
                      <h3 data-toggle="collapse" data-target="#collapse22" style="color:white;"><span>24.</span> Otros
                      </h3>
                  </div>
                  <div id="collapse22" class="collapse" data-parent="#accordionOne">
                      <div class="card-body">
                          <p>Las demás que le corresponde por mandato de la ley y las que le asigne la
                              Gerencia Municipal.</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>



